import React, { useState } from 'react';
import axios from 'axios';
import '../custom.css';
import * as AppConstants from '../AppConstants';
import { toast } from 'react-toastify';
import CenteredSpinner from './CenteredSpinner';
import moment from 'moment';

export const Login = () => {
  const [username, setUsername] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState('');

  const handleChangeUsername = (e) => {
    setUsername(e.target.value);
  };

  const handleChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const signIn = () => {
    axios.defaults.baseURL = AppConstants.BASE_URL;
    const options = {
      method: 'POST',
      url: `/user/LoginWithSettings`,
      headers: {
        accept: 'application/json',
        ApiKey: AppConstants.API_KEY,
        'Content-Type': 'application/json',
      },
      data: { username: username, password: password },
    };
    setIsLoading(true);
    const uninterceptedAxiosInstance = axios.create();
    uninterceptedAxiosInstance
      .request(options)
      .then((response) => {
        axios.defaults.headers.common = {
          ApiKey: AppConstants.API_KEY,
          Authorization: `Bearer ${response.data.accessToken}`,
          accepts: 'application/json',
        };
        localStorage.setItem('token', response.data.accessToken);
        localStorage.setItem('userId', response.data.userId);
        localStorage.setItem('username', response.data.username);
        localStorage.setItem('staffMemberId', response.data.staffMemberInfo.id);
        localStorage.setItem('lastInteraction', moment());
        
        localStorage.setItem(
          'geoRegionId', 
          response.data.staffSettings.geoRegionId === null ? 1 : response.data.staffSettings.geoRegionId
        );
        
        localStorage.setItem(
          'staffMemberInfo',
          JSON.stringify(response.data.staffMemberInfo),
        );
        localStorage.setItem(
          'staffMemberSettings',
          JSON.stringify(response.data.staffSettings),
        );        
        //Get Sys_Settings
        const options = {
          method: 'GET',
          url: `/setting`,
        };
        axios
          .request(options)
          .then((response) => {
            localStorage.setItem(
              'sys_settings',
              JSON.stringify(response.data),
            );

            //Reload page, Routing will handle the redirect
            window.location.reload();
          })
          .catch((error) => {});
      })
      .catch((error) => {
        setIsLoading(false);
        if (error?.response?.status === 401) {
          //Wrong Username/Password
          toast.error(`Invalid Username / Password.`, {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: false,
            progress: undefined,
          });
        } else {
          toast.error(
            `Internal Server Error, please contact support.`,
            {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              draggable: false,
              progress: undefined,
            },
          );
        }
      });
  };

  if (isLoading) {
    return <CenteredSpinner />;
  }

  return (
    <div className="login-page d-flex flex-column align-items-center justify-content-center">
      <div className="login-brand mb-3 text-center">
        <img
          src={AppConstants.BASE_URL_FILE + 'AppShell/logo.png'}
          alt="Company Logo"
          className="login-brand-logo"
        />
      </div>
      <div className="login-card shadow">
        <div className="login-hero text-center">
          <p className="mb-1 text-white-50 small text-uppercase">Welcome to Realty</p>
          <h4 className="mb-0 text-white">Sign in to continue</h4>
        </div>

        <div className="login-body">
          <div className="form-group">
            <label htmlFor="username" className="form-label font-weight-bold">
              Username
            </label>
            <input
              autoComplete="on"
              name="username"
              id="username"
              className="form-control login-input"
              placeholder="Enter your username"
              onChange={handleChangeUsername}
            />
          </div>
          <div className="form-group">
            <label htmlFor="Password" className="form-label font-weight-bold">
              Password
            </label>
            <input
              autoComplete="on"
              type="password"
              name="Password"
              className="form-control login-input"
              id="Password"
              onChange={handleChangePassword}
              placeholder="Enter your password"
            />
          </div>
          <div className="d-flex align-items-center justify-content-center mt-4">
            <button
              type="button"
              className="btn login-submit-btn login-submit-btn--wide"
              onClick={() => signIn()}
            >
              Sign In
            </button>
          </div>
          <div className="text-right mt-3">
            <a href={AppConstants.WEB_APP_URL + '?force'} className="text-primary">Web App</a>
          </div>
        </div>
      </div>
      <div className="login-build mt-3">
        <div className="login-build">Build: {AppConstants.BUILD_NUMBER} {AppConstants.BUILD_DATE}</div>
      </div>
    </div>
  );
};
